import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';

const CATEGORIES = ['Insurance', 'HOA Rules', 'Warranty', 'Contract', 'Manual', 'Other'];

export default function PropertyDocUpload({ propertyId, onUploaded, onClose }) {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('Other');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleUpload = async () => {
    if (!file) { setError('Please select a file.'); return; }
    if (!title.trim()) { setError('Title is required.'); return; }
    setUploading(true);
    setError('');

    const path = `${propertyId}/${Date.now()}-${file.name}`;
    const { error: uploadError } = await supabase.storage
      .from('property-documents')
      .upload(path, file);

    if (uploadError) {
      setError(uploadError.message);
      setUploading(false);
      return;
    }

    await supabase.from('property_documents').insert({
      property_id: propertyId,
      title: title.trim(),
      category,
      storage_path: path,
      filename: file.name,
    });

    setUploading(false);
    onUploaded();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Upload Document</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>File *</label>
            <label className="photo-upload-area">
              <input
                type="file"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif"
                onChange={e => setFile(e.target.files[0])}
                style={{ display: 'none' }}
              />
              <span>{file ? file.name : '+ Select File'}</span>
            </label>
          </div>
          <div className="form-group">
            <label>Title *</label>
            <input
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="e.g. Homeowners Insurance Policy"
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <select value={category} onChange={e => setCategory(e.target.value)}>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleUpload} disabled={uploading}>
            {uploading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </div>
    </div>
  );
}
